import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import UsersDeclarantsStore from "../stores/UsersDeclarantsStore";
import DateRange from "../components/declarants/dateRange";
import Summary from "../components/declarants/summary";
import Search from "../components/declarants/search";
import Settings from "../components/declarants/Settings";
import CreateDeclarant from "../components/declarants/createDeclarant";
import DeclarantsContainer from "../components/declarants";
import { DateRangeDate, IObjectMap } from "../interfaces/common";
import COLUMNS from "../components/tables/createdTable/config";
import {
  CREATED_ACTIVE_COLUMNS,
  CREATED_ORDER_COLUMNS,
} from "../constants/settings";
import updateSortingAndFiltersOfColumns from "../helpers/filters";
import SettingsStore from "../stores/SettingsStore";
import UserStore from "../stores/UserStore";
import RefreshButton from "../components/buttons/RefreshButton";

const declarantStore = new UsersDeclarantsStore();
let isLoaded = false;

const CreatedPage: React.FC<{
  settingsStore: SettingsStore;
  userStore: UserStore;
}> = ({ settingsStore, userStore }) => {
  useEffect(() => {
    if (isLoaded) {
      return;
    }

    declarantStore.load({}, true);
    isLoaded = true;
  }, []);

  const header: React.ReactNode[] = [
    <DateRange
      store={declarantStore}
      startDate={declarantStore.parameters.start_date as DateRangeDate}
      endDate={declarantStore.parameters.end_date as DateRangeDate}
    />,
    <Search store={declarantStore} />,
    <Summary store={declarantStore} />,
  ];

  const filters: React.ReactNode[] = [
    <CreateDeclarant
      clients={settingsStore.clients || []}
      noClient={settingsStore.noClient}
      departments={settingsStore.departments || []}
    />,
    <RefreshButton refresh={declarantStore} />,
    <Settings reorderable />,
  ];

  useEffect(() => {
    settingsStore.setColumns(
      updateSortingAndFiltersOfColumns(
        userStore.authorizedOnly(COLUMNS(settingsStore)) ||
          COLUMNS(settingsStore),
        declarantStore.parameters as IObjectMap
      ),
      CREATED_ORDER_COLUMNS,
      CREATED_ACTIVE_COLUMNS
    );
  }, [
    settingsStore,
    userStore,
    settingsStore.isEnabledReorder,
    declarantStore.parameters,
  ]);

  return (
    <DeclarantsContainer
      settingsStore={settingsStore}
      loadStore={declarantStore}
      header={header}
      filters={filters}
    />
  );
};

export default inject(({ store }) => ({
  settingsStore: store.settingsStore,
  userStore: store.userStore,
}))(observer(CreatedPage));
